import { render, staticRenderFns } from "./BarEdpBySecteurChart.vue?vue&type=template&id=f845e608&"
import script from "./BarEdpBySecteurChart.vue?vue&type=script&lang=ts&"
export * from "./BarEdpBySecteurChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports